import { render, staticRenderFns } from "./rain-pipe-detail.vue?vue&type=template&id=bbaf141a&scoped=true"
import script from "./rain-pipe-detail.vue?vue&type=script&lang=js"
export * from "./rain-pipe-detail.vue?vue&type=script&lang=js"
import style0 from "./rain-pipe-detail.vue?vue&type=style&index=0&id=bbaf141a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbaf141a",
  null
  
)

export default component.exports